document.addEventListener('DOMContentLoaded', () => {
  //MicroModal
  MicroModal.init({ disableScroll: true });
  //ScrollHint
  new ScrollHint('.js-scroll');

  // スムーススクロール
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (!target) return;

      e.preventDefault();

      window.scrollTo({
        top: target.offsetTop,
        behavior: 'smooth',
      });
    });
  });

  // works　modal内スライダー
  document.querySelectorAll('.slider').forEach((slider) => {
    const mainEl = slider.querySelector('.main-carousel');
    const thumbEl = slider.querySelector('.thumbnail-carousel');
    if (!mainEl || !thumbEl) return;

    const main = new Splide(mainEl, {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
    });

    const thumbnails = new Splide(thumbEl, {
      perPage: 3,
      pagination: false,
      isNavigation: true,
      arrows: false,
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  });

  const tabs = document.querySelectorAll('.History__tab');
  const panels = document.querySelectorAll('.History__panel');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.getAttribute('data-tab');

      tabs.forEach((t) => t.classList.remove('is-active'));
      panels.forEach((p) => p.classList.remove('is-active'));

      tab.classList.add('is-active');
      document.getElementById(target).classList.add('is-active');
    });
  });

  const header = document.getElementById('js-header');

  window.addEventListener('scroll', () => {
    if (window.innerWidth <= 767) return;

    if (window.scrollY > 50) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  });

  document.getElementById('hamburger').addEventListener('click', function () {
    // ハンバーガーメニューのクラスをトグル
    document.querySelector('.menu-right').classList.toggle('open');
    // ハンバーガーのクロス用クラスをトグル
    document.body.classList.toggle('hamburger-active');
  });
  // menu-rightをクリックした時の処理
  document.querySelector('.menu-right').addEventListener('click', function () {
    // ハンバーガーメニューのクラスを閉じる
    this.classList.remove('open');
    // ハンバーガーのクロス用クラスも削除
    document.body.classList.remove('hamburger-active');
  });

  const textSlider = document.getElementById('text-slider');
  if (textSlider) {
    new Splide(textSlider, {
      type: 'loop',
      drag: false,
      arrows: false,
      pagination: false,
      autoWidth: true,
      focus: 0,
      autoScroll: {
        speed: 1.5,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
    }).mount(window.splide.Extensions);
  }

  gsap.registerPlugin(ScrollTrigger);

  gsap.utils.toArray('.js-fadeIn').forEach((el) => {
    let delay = 0;

    if (el.classList.contains('delay-1')) delay = 0.3;
    if (el.classList.contains('delay-2')) delay = 0.6;
    if (el.classList.contains('delay-3')) delay = 1;

    gsap.from(el, {
      opacity: 0,
      y: 40,
      duration: 0.8,
      ease: 'power2.out',
      delay: delay,
      scrollTrigger: {
        trigger: el,
        start: 'top 80%',
        toggleActions: 'play none none none',
      },
    });
  });

  // main.js

  if (document.querySelector('.MainVisual')) {
    const tl = gsap.timeline();

    tl.from('.MainVisual__bg-container', {
      opacity: 0,
      scale: 1.1,
      duration: 2,
      ease: 'power2.out',
    }).from(
      ['.MainVisual__content-deco', '.MainVisual__title-container'],
      {
        opacity: 0,
        y: 40,
        duration: 1.8,
        ease: 'power2.out',
      },
      '-=1.1',
    );
  }
});
